var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskCenteredLayout",
    [
      _c("HelpModal"),
      _vm._v(" "),
      _c(
        "BaseButton",
        { class: _vm.$style.closeBtn, attrs: { "button-style": "Main" } },
        [_vm._v("Close")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskHelpMessage.vue?vue&type=template&id=d5d20428&
// module id = null
// module chunks = 